import React from 'react';
import { formatValidInput, formatValidSelect } from '../../../helpers/FormatHelper';
import { getStyle } from '../../../styles/styles';
import { useEffect } from 'react';
import { useState } from 'react';
import useLookUpTables from '../../maintenance/complaints/useLookUpTables';
import DynamicSelect from '../../shared/DynamicSelect';
import NumberInput from '../../shared/NumberInput';
const style = getStyle();

const DeliveryFeeDetailsForm = ({deliveryFee, deliveryMethods, save}) => {

    const [deliveryFeeID, setDeliveryFeeID] = useState(-1);
    const [deliveryMethod, setDeliveryMethod] = useState('');
    const [deliveryRegion, setDeliveryRegion] = useState('');
    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(0);
    const [feeValue, setFeeValue] = useState(0);
    const lookUpTables = useLookUpTables('BNDelivery Regions');
    const [validations, setValidations] = useState({
        deliveryMethod: true,
        deliveryRegion: true,
        minValue: true,
        maxValue: true,
        feeValue: true
    })

    useEffect(()=>{

        if(deliveryFee && deliveryFee.DeliveryFeeID)
        {
            setDeliveryFeeID(deliveryFee.DeliveryFeeID);
            setDeliveryMethod(deliveryFee.DeliveryFeeDescription);
            setDeliveryRegion(deliveryFee.DeliveryRegion);
            setMinValue(deliveryFee.FromTier);
            setMaxValue(deliveryFee.ToTier);
            setFeeValue(deliveryFee.DeliveryCost);
        }
        else
        {
            setDeliveryFeeID(-1);
            setDeliveryMethod('');
            setDeliveryRegion('');
            setMinValue(0);
            setMaxValue(0);
            setFeeValue(0);
        }

    },[deliveryFee])
   

    const handleClearClick = () =>{

        setDeliveryFeeID(-1);
        setDeliveryMethod('');
        setDeliveryRegion('');
        setMinValue(0);
        setMaxValue(0);
        setFeeValue(0);
    }

    const isValid = () =>{
         const prev = validations;
        let valid = true;
        let message ='';

        const validationsSave = {
            ...prev,
                deliveryMethod: deliveryFeeID > 0,
                deliveryRegion: (deliveryMethod !== null && deliveryMethod !== undefined && deliveryMethod !== ''),
                minValue: minValue < maxValue,
                maxValue: maxValue >= 0 && maxValue > minValue,
                feeValue: feeValue >= 0
        };

        setValidations(validationsSave);

        return Object.values(validations).every(Boolean)

    }

    const handleSaveClick = ()=>{
        if(isValid)
        {
            const model = {
                DeliveryFeeID: deliveryFeeID,
                DeliveryRegion : deliveryRegion,
                FromTier: minValue,
                ToTier: maxValue,
                DeliveryCost: feeValue,
                UserID: localStorage.getItem('UserID')
            }
            save(model);
        }
    }

    const dropdownDeliveryMethodChangeHandler = (item) => {
        if(item.value && item.value !== 'select')
        {
            setDeliveryFeeID(item.DeliveryFeeID);
            setDeliveryMethod(item.value);
        }
        else{
            setDeliveryFeeID(-1);
            setDeliveryMethod('');
        }
    }

    const dropdownDeliveryRegionChangeHandler = (item) => {
      if(item.value && item.value !== 'select')
      {
        setDeliveryRegion(item.value);
        }
        else
        {
            setDeliveryRegion('');
        }
    }

    const changeMinValue = (e) =>{
        setMinValue(e.target.value)
    }

    const changeMaxValue = (e) =>{
        setMaxValue(e.target.value)
    }

    const changeFeeValue = (e) =>{
        setFeeValue(e.target.value)
    }

    return(<> 
                <div className="uk-form-stacked uk-grid">
                    <div className="uk-width-1-2 uk-form-stacked">
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="form-delivery-method" style={style.boldLabel}>Delivery Method</label>
                            <div className="uk-form-controls">
                                <DynamicSelect
                                    className={formatValidSelect(validations.deliveryMethod)}
                                    listHasPlaceholder={true}
                                    data={deliveryMethods}
                                    objValue={{value:deliveryMethod}}
                                    getValue={dropdownDeliveryMethodChangeHandler}/> 
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked">
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="form-delivery-region" style={style.boldLabel}>Delivery Region</label>
                            <div className="uk-form-controls">
                                <DynamicSelect
                                    className={formatValidSelect(validations.deliveryRegion)}
                                    listHasPlaceholder={true}
                                    data={lookUpTables.BNDeliveryRegions}
                                    objValue={{value:deliveryRegion}}
                                    getValue={dropdownDeliveryRegionChangeHandler}/> 
                            </div>
                        </div>
                    </div>

                    <div className="uk-width-1-2 uk-form-stacked">
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="form-delivery-method" style={style.boldLabel}>Order Size</label>
                            <div className="uk-form-controls uk-grid">
                                <div className="uk-width-1-2 uk-form-stacked">
                                    <NumberInput id={`min`} key={`min`} className={formatValidInput(validations.minValue)} value={minValue} 
                                                    scale={2} type="Currency" onChange={changeMinValue} />
                                </div>
                                <div className="uk-width-1-2 uk-form-stacked">
                                    <NumberInput id={`max`} key={`max`} className={formatValidInput(validations.maxValue)} value={maxValue} 
                                                    scale={2} type="Currency" onChange={changeMaxValue}/>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked">
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="form-delivery-method" style={style.boldLabel}>Delivery Cost</label>
                            <div className="uk-form-controls">
                                <NumberInput id={`fee`} key={`fee`} className={formatValidInput(validations.feeValue)} value={feeValue} 
                                                    scale={2} type="Currency" onChange={changeFeeValue}/>
                            </div>
                        </div>
                    </div>

       
                    <div className="uk-width-2-2 uk-margin">
                        <button className="uk-button uk-button-green" onClick={handleClearClick}>Clear Fields</button>
                        <button className="uk-button uk-button-green" onClick={handleSaveClick}>Save</button>
                        <hr/>
                    </div>
                    
                </div>
            </>
        );
    
}

export default DeliveryFeeDetailsForm